var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_28_184",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_28_184",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEzklEQVR4nO2dW6xeQxTH55TSiobSOggt0QZB6hK3pBJSb+2TtG49RQT15o1EiHjDm6SNEvUgLklfPRJCi5C6BEWrbVIiRThN2h4cevqTifXVzufb+5vZe/be881ev2S/nOSbNWv992XNzJo5xiiKoiiKoiiKoiiKoiiKoiiKoijOAOPAFcAqYE3i1yrxdTyqW0Q69QzwHd1lF/A0sKxNIRYDLwNH245GRNhYbAGWNC2GfWSn2vY+Yv4AJpoS4wl9KpyflsfrFuNet74oGdbXJcZy4C/cOAxMJn4ddozFNHB9aDFmAZ8OMfyefFtONR0BmC8+bx0Sm+3AWEjDEwXG/rSvMtNxgPskFnncEdLYBwUfrluCGRpxgNUFCc+2UEbOBGZyjLwQxEhCAJtzYjUTZFQP3F3wdCwK4kVCAOcVPCXrQo07BrE9iAcJQn4CVH1cAjyf0/grQXqfIMBrOTHbFKJxOzcziI1Bep8gwMacmG2pU5ANQXqfIMCGNgR5q0uDQFdsTCQ2jQti+Q14BJhrOg5wAvAA8HNBvGoXpMcP0pnjTMfg32klO32yxyFOjQnSY4ftnOkIwM3AZx7xaVyQHnaqZblJFOBq4O0ScWlNkB5vAEtNIlB92bp1QZA1FDu4PMuMKMAC4Kkhs7mtC/K9LL64cgh4EphnRgRgnvTZ9t2VaYlN44LYwc8iufvzZoMH8aukyieaSAFmS9a4v0zFSVsDw2MjdeBS+V74sE+cnmUiARiTFNa3xuxN4KpMO+0K0pcGfuLpzJfAStMywApZavXhq0FpfjSC9N1lu0vcZVdW7rC/f5eUSFz2FQ2EoxJkwHv4pxLv4Qsqd3y4X+fK9+9Iie/fnCFtxydI5vcnixMHS6TK45Ud+H9/TpMU1lYXujIlvznF0Ua8gmTaWQg8C/ztEYhDEojKqTJwktwYBzzsz8hA8GxPW/ELkmnvQmnTZ7T7C/AQcHzJyb+7gB/x/6ZdVtLH0REk0+41wDueQfpWEganojPJ+r7wtPEhcENF30ZPkL6gfe4ZtI+AGwvavA5417PNr0PNVI+0IH1rCntLvFaObZIBLiqRwgZfyxl5QTK25gIPSzGzK0ekOG2zZwo7KbaCr3YmI0hfEbPNrn4nPNOSUi80NZGcID2Ac0oM3opSWOvL+aZmkhWkB3BxxXUZ+6253DRE8oL0sBtfZB+KKx8DN5mG6YwgfamynSXOY6fPeCU0nRMkM3n5YN8i0n7522zTIp0UpIddeZQnZkUsq5CdFiRGVJDIUEEiQwWJDBUkMlSQyFBBIkMFiQwVJDJUkMhoSxDdFt3StuhNOY2/WrnxRAFez4nZcyEa16M1IjtawxaZDcIWui2ubKBbh89M1H0804tBvEgI4KWcWNm6gDNCGXm/4ClZHcRIAgC3FjwdW0MaupPispr7TccB1g/Zc3m7CVxZOGxn1DbgNlvubzoCcLr4nPcGyRZbjNVR8THtsZ9iMvFryjEWNmbXBhUjI8o9jp1Q/qPe1znwmB417oT9uD9aqxh9x6HqYfz52O1yaxsRIyNKmUMDUudoU5tWi4RZJpXqdndTV/lGYlBqC1xt2JGoLWq2BwFE8C+J1tR8rRRfa9vWoCiKoiiKoiiKoiiKoiiKoiiKYhLkH+9aYxdYLGIRAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.abe1c628be9a5b678f8fd0690d8d5f12.svg";
export { ForwardRef as ReactComponent };